import React, {Component} from 'react';
import './card.css';


class GroupCardTopic extends Component  {
    constructor (props) {
        super(props);
        this.handleNameClick = this.handleNameClick.bind(this);
    }
    
    handleNameClick () {
        this.props.handleGroupLineNameClick(this.props.topic);
    }

    render () {
        let topic = this.props.topic; 

        let image_url = this.props.image_url;
        let image_element = <img alt='.' className='group_line_image' src={image_url}/>;
        if (image_url === '' || image_url === 'none') {
            image_element = <div className='group_line_image'></div>;
        }

        const d = new Date(topic.property.day) 
        
        // TBD: Decide best element type to use for clickable name
        return (
            <div  className='card_line'> 
              {image_element}
              {/* TBD: add rollover text describing click action */}
              <a
                    href="#0"
                    onClick={this.handleNameClick} 
                    className='group_line_name'
                    title='View Wikipedia summary'
                    >
                    {topic.name}
                </a>
               <div className='group_line_year'> {d.getFullYear()}</div>
            </div>
        )
    }
}


export default GroupCardTopic;